import type React from 'react';
import { useTranslation } from 'react-i18next';

import { IconDirDown, IconDirLeft, IconDirRight } from '../Icon';
import { SrOnly } from '../SrOnly';
import {
  QuickNav,
  QuickNavDummy,
  QuickNavOption,
  QuickNavSelect,
  QuickNavTitle,
  StepButton,
  Wrapper,
} from './wrapper';

interface PaginationButtonProps {
  onClick: () => void;
  disabled?: boolean;
  title?: string;
}

interface PaginationSelectOptionProps {
  value: number;
  disabled?: boolean;
}

interface PaginationSelectProps {
  pages: PaginationSelectOptionProps[];
  value: number;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

interface PaginationProps {
  prev: PaginationButtonProps;
  next: PaginationButtonProps;
  pages?: PaginationSelectProps;
  currentPage: number;
}

const Pagination = ({ prev, next, pages, currentPage }: PaginationProps) => {
  const { t } = useTranslation('common');

  return (
    <Wrapper>
      <StepButton
        onClick={prev.onClick}
        title={prev.title || t('goToPreviousPage', { ns: 'common' }) || ''}
        disabled={prev.disabled}
      >
        <SrOnly>{t('goToPreviousPage', { ns: 'common' })}</SrOnly>
        <IconDirLeft />
      </StepButton>
      {pages && (
        <QuickNav>
          <QuickNavDummy>
            <QuickNavTitle>
              {t('pageIndexOfTotal', {
                ns: 'common',
                index: currentPage,
                total: pages.pages.length,
              })}
            </QuickNavTitle>
            <IconDirDown />
          </QuickNavDummy>
          <QuickNavSelect value={pages.value} onChange={pages.onChange}>
            {pages.pages.map((p) => (
              <QuickNavOption key={p.value} value={p.value} disabled={currentPage === p.value}>
                {t('pageIndex', { ns: 'common', index: p.value })}
              </QuickNavOption>
            ))}
          </QuickNavSelect>
        </QuickNav>
      )}
      <StepButton
        onClick={next.onClick}
        title={next.title || t('goToNextPage', { ns: 'common' }) || ''}
        disabled={next.disabled}
      >
        <SrOnly>{t('goToNextPage', { ns: 'common' })}</SrOnly>
        <IconDirRight />
      </StepButton>
    </Wrapper>
  );
};

export default Pagination;
